"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsExportHighchartsButton = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const HeaderExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/highcharts/HeaderExportHighchartsButton");
const AppPubSub_1 = require("src/hello_assets/src/util/PubSub/AppPubSub");
const HighchartsWithOptionsComponent_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsWithOptionsComponent");
const lodash_1 = __importDefault(require("lodash"));
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const EventsHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsHighchartsComponent");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
exports.EventsExportHighchartsButton = React.memo(() => {
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const eventsPageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    const onClickExportHighcharts = (0, react_1.useCallback)(() => {
        AppPubSub_1.AppPubSub.publish(HighchartsWithOptionsComponent_1.PubSubAction_ExportHighcharts, { chartIdentifier: EventsHighchartsComponent_1.eventsChartIdentifier });
    }, []);
    const disabled = eventsPageDataContext.state.inProgress || highchartsOptionsContext.state.error.isError || lodash_1.default.isNil(eventsPageDataContext.state.data);
    return React.createElement(HeaderExportHighchartsButton_1.HeaderExportHighchartsButton, { onClick: onClickExportHighcharts, disabled: disabled });
});
